import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function getOrderByOrderId(order_id, token) {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.GET_ORDER_BY_ORDER_ID_REQUEST,
			payload: {
				loading: true
			}
		});

		const response = await API.orders.getOrderByOrderId({ order_id, token });
		if (response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_ORDER_BY_ORDER_ID_ERROR,
				payload: {
					loading: false,
					meta: response.meta
				}
			});
			return;
		}

		dispatch({
			type: ActionTypes.GET_ORDER_BY_ORDER_ID_SUCCESS,
			payload: {
				loading: false,
				order: response.data.order || null,
				meta: response.meta
			}
		});
	};
}

export function resetPage() {
	return async (dispatch) => {
		dispatch({
			type: ActionTypes.RESET_RECEIPT_PAGE
		});
	};
}
